<style lang="scss" scoped>
  @import '../../../sass/variables';

  input {
    cursor: pointer;
    line-height: 34px;
    padding: 0.375rem 1.2rem;
    position: relative;
    opacity: 0;
  }

  .text {
    left: 0;
    top: 50%;
    width: 100%;
    cursor: none;
    user-select: none;
    padding: 0 1.2rem;
    position: absolute;
    pointer-events: none;
    transform: translateY(-50%);
  }

  .placeholder {
    color: $gray-light;
  }

  .icon {
    cursor: initial;
    font-size: 1rem;
    position: absolute;
    top: 16px;
    right: 1.2rem;

    &.uploading::after {
      color: $purple;
      content: "\f110";
    }
  }

  .icon-times {
    cursor: pointer;
    position: absolute;
    top: -24px;
    right: 1.3rem;
  }
</style>

<template>
  <span class="form-control">
    <input
      class="w-100"
      type="file"
      ref="file"
      @change="update"
    ><span
      class="text placeholder"
      v-if="! filename"
    >Selecione uma imagem</span><span
      class="text"
      v-else
    >{{ filename | truncate(30) }}</span><i
      class="icon uploading fa fa-spin"
      v-if="uploading"
    />
    <IconFilledChecked
      class="icon"
      :size="18"
      v-if="uploaded"
    />
    <IconFilledError
      class="icon"
      :size="18"
      v-if="error"
    /><a
      class="icon-times"
      v-b-tooltip="__('Remover imagem de fundo')"
      @click.stop="reset()"
      v-if="filename"
    >
      <IconTimes :size="15" /></a></span>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: ['value'],

  computed: {
    filename () {
      if (this.file == '---') {
        return '';
      }

      const splited = this.file.split('|')[1];

      return splited || this.file;
    },
  },

  mounted () {
    if (this.filename) {
      this.uploaded = true;
    }
  },

  data () {
    return {
      uploading: false,
      uploaded: false,
      error: false,
      file: this.value,
    };
  },

  methods: {
    reset ({
      error = false, uploaded = false, uploading = false, file = '',
    } = {}) {
      this.error = error;
      this.uploaded = uploaded;
      this.uploading = uploading;
      this.file = file;

      this.$emit('input', '---');
    },

    update () {
      this.reset({ uploading: true });

      const file = this.$refs.file.files[0];
      const form = new FormData();
      form.append('file', file);

      this.$http.post('/file/upload', form)
        .then(({ data: { location } }) => {
          this.reset({ uploaded: true });
          this.file = `${location}|${file.name}`;
          this.$emit('input', this.file);
        })
        .catch(() => {
          this.reset({ error: true });
        });
    },
  },
};
</script>
